import Layout from "../layout"

class App extends Layout {
    constructor() {
        super()
        window.RAF.on("animate", (delta) => this.render(delta))
    }
    
    loaded() {
        this.preloader.hide()
    }
    
    render() {
        const time = new Date().getTime() * .1
        STATS.update()
    }

}

const _app = new App()